import { useState, useEffect } from "react";
import FeaturesAccordion from "./featuresAccordion";
import FeaturesModal from "./featuresModal";
import useApi from "../../../hooks/apiService";
import { useTranslation } from "react-i18next";
import NoDataTables from "../../../components/noDataTables";

export default function Features() {
  const { t } = useTranslation();
  const { fetchData, postData, updateData, deleteData } = useApi();
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingFeature, setEditingFeature] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState("");

  const fetchFeatures = async () => {
    try {
      const res = await fetchData("/features");
      setTableData(res.data || []);
    } catch (err) {
      console.error("Erro ao buscar features", err);
    }
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  const handleShow = () => {
    setIsEdit(false);
    setEditingFeature(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEdit(false);
    setEditingFeature(null);
    setError("");
  };

  const refreshFeatures = () => {
    fetchFeatures();
  };

  const handleDataDeleted = (deletedId) => {
    setTableData((prev) => prev.filter((item) => item.id !== deletedId));
  };

  const handleOpenEdit = (feature) => {
    setIsEdit(true);
    setEditingFeature(feature);
    setShow(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/features/${id}`);
      handleDataDeleted(id);
    } catch (err) {
      console.error("Erro ao deletar feature", err);
      setError(t("Erro ao deletar feature"));
    }
  };

  return (
    <>
      <br />
      {tableData.length > 0 ? (
        <FeaturesAccordion
          features={tableData}
          onShowModal={handleShow}
          onEditFeature={handleOpenEdit}
          onDeleteFeature={handleDelete}
          deleteData={deleteData}
          updateData={updateData}
          onDataEdited={refreshFeatures}
        />
      ) : (
        <NoDataTables
          message={t("Nenhuma feature cadastrada")}
          addItem={handleShow}
        />
      )}

      <FeaturesModal
        show={show}
        onHide={handleClose}
        isEdit={isEdit}
        editingFeature={editingFeature}
        onDataAdded={refreshFeatures}
        onDataEdited={refreshFeatures}
        postData={postData}
        updateData={updateData}
        error={error}
        setError={setError}
      />
    </>
  );
}
